import { useMutation, useQueryClient } from "react-query";
import { usePriceListState } from "atoms/priceListAtom";

import { deletePriceListItem } from "./index";

export const useDeletePriceListItem = () => {
  const queryClient = useQueryClient();
  const { setPriceListState } = usePriceListState();

  return useMutation(["delete-price-list-item"], deletePriceListItem, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-pricelist"] });
      setPriceListState({ activeItem: null });
    },
  });
};
